import analyticsUtils from './index.js'

export default function trackEvent(
  eventCategory?: string,
  eventAction?: string,
  eventLabel?: string
): void {
  return analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.USER_CLICK,
    eventCategory,
    eventAction,
    eventLabel,
  })
}

export const trackEventWithSelector = (
  tracker: (label: string) => void,
  selector = 'a,button'
) => (e: React.MouseEvent): void => {
  if (e?.target instanceof Element) {
    const desiredTarget = e.target.closest(selector)
    if (e.currentTarget.contains(desiredTarget)) {
      tracker(e?.target?.textContent ?? '')
    }
  }
}
